<style></style>

<template>
    <div class="component-container">
        <div class="row" v-if="successMessage.length && !isProgramUser">
            <div class="col">
                <div class="alert alert-success" 
                    role="alert" 
                    v-for="(message, idx) in successMessage"
                    :key="idx"
                >
                    {{message}}
                </div>
            </div>
        </div>
        <!-- <div class="alert alert-purple">loading: {{loading ? 'yes' : 'no'}}</div>   -->
        <h2 v-show="!edit" class="mt-5">
            Your Action Plan 
            <button 
                class="btn-orange-blue btn-sm" 
                v-on:click="toggleEdit()"
                v-if="!isComplete && isProgramUser"
            >Edit Plan</button>
        </h2>
        <steps :action-plan="apCopy" :edit="edit" ref="steps"></steps>

        <h2 v-show="!edit && !isComplete && isProgramUser" class="mt-5">
            Goal Date 
            <button 
                class="btn-orange-blue btn-sm"
                v-on:click="toggleEdit()"
                v-if="isProgramUser"
            >Change Date</button>
        </h2>
        <goal-date :action-plan="apCopy" :edit="edit" ref="goalDate"></goal-date>

        <div class="border-top p-2 mt-5 mb-5">
            <update-nav 
                :action-plan="apCopy" 
                :section="section"
                :most-recent-assessment="actionPlan.mostRecentAssessment"
                v-show="!edit"
                v-on:goalreached="completeActionPlan()"
                v-if="isProgramUser"
            ></update-nav>

            <div v-if="!isProgramUser">
                <h2 class="mt-3 lighter mb-0 border-0">What would you like to do next?</h2>
                <button type="button" class="btn btn-orange-blue" v-on:click="createNewLog" data-toggle="modal" data-target="#activityLogFormModal">
                    Add TA Activity
                </button>
            </div>

            <div class="mt-2">
                <small>
                    <a :href="$basePath+'/action-plans/'+actionPlan.id+'/print'" class="text-orange" target="assessment-results-print">
                        <small><span class="fa fa-print"></span></small> 
                        Print Your Plan
                    </a>
                </small>
                &nbsp;&nbsp;|&nbsp;&nbsp;
                <small>
                    <a :href="$basePath+'/tips-and-materials/'+section.module.slug+'/'+section.slug" class="text-orange">
                        <small><span class="fa fa-search"></span></small> 
                        Related Tips &amp; Materials
                    </a>
                </small>
                <span v-if="isProgramUser">
                    &nbsp;&nbsp;|&nbsp;&nbsp;
                    <small>
                        <a :href="$basePath+'/action-plans'" class="text-orange">Action Planning Dashboard</a>
                    </small>
                </span>
            </div>

            <goal-selection-nav :progress="'66%'" v-if="edit">
                <template #back>
                    <button @click="navigateBack()" class="btn-orange-blue">
                            <span class="fa fa-caret-left"></span>
                            Go Back
                    </button>                    
                </template>
                <template #next>
                    <button 
                        type="button" 
                        class="btn-orange-blue" 
                        v-on:click="saveActionPlan"
                    >
                        Save
                        <span class="fa fa-caret-right"></span>
                    </button>        
                </template>
            </goal-selection-nav>            
        </div>        
    </div>
</template>

<script>
    import moment from 'moment'
    import Steps from './Steps'
    import GoalDate from './GoalDate'
    import UpdateNav from './UpdateNav'
    import Auth from '../../auth'
    import ActivityLogForm from '../consultants/ActivityLogForm'
    import GoalSelectionNav from './goal_selection/GoalSelectionNav'

    export default {
        components: {
            Steps,
            GoalDate,
            UpdateNav,
            GoalSelectionNav,
            ActivityLogForm
        },
        props: {
            actionPlan: {
                required: true,
                type: Object
            },
            section: {
                required: true,
                type: Object
            },
            logAreas: {
                required: true,
                type: Array
            },
            logTypes: {
                required: true,
                type: Array
            }
        },
        data() {
            return {
                apCopy: {
                    steps: [],
                    mostRecentAssessment: {
                        survey: {},
                        id: null
                    }
                },
                edit: false,
                pendingRequests: 0,
                successMessage: [],
                currentLog: null
            }
        },
        computed: {
            isComplete: function () {
                return (this.apCopy.date_completed !== null)
            },
            isStarted: function () {
                return (this.apCopy.date_started !== null)
            },
            loading: function() {
                return this.pendingRequests.length > 0
            },
            isProgramUser: function() {
                return Auth.is('program-user')
            },
            isTa: function() {
                return Auth.is('ta-consultant')
            }
        },
        methods: {
            toggleEdit() {
                this.edit = !this.edit;
                this.$emit('mode', (this.edit) ? 'edit' : 'update');
            },
            startActionPlan() {
                this.$refs.steps.updateEditingSteps()
                this.openPendingRequest();
                this.updateActionPlan({ date_started: moment().format('YYYY-MM-DD') })
                    .then((response) => {
                        this.closePendingRequest();
                        this.edit = false
                    })
                    .catch((error) => {
                        console.error(error);
                        this.closePendingRequest();
                        alert('there was a problem starting the action plan')
                        return error
                    });
            },
            completeActionPlan() {
                this.openPendingRequest();
                this.updateActionPlan({ date_completed: moment().format('YYYY-MM-DD') })
                    .catch((error) => {
                        this.closePendingRequest();
                        alert('there was a problem marking the action plan complete')
                        return error
                    });
            },
            updateActionPlan(data) {
                this.openPendingRequest();
                return axios.put('/api/action-plans/' + this.apCopy.id, data)
                    .then((response) => {
                        this.closePendingRequest();
                        this.apCopy = response.data
                        return response
                    });
            },
            syncActionPlan() {
                this.apCopy = JSON.parse(JSON.stringify(this.actionPlan))
            },
            openPendingRequest() {
                this.pendingRequests++
            },
            closePendingRequest() {
                if (this.pendingRequests > 0) {
                    this.pendingRequests--
                }
            },
            showNewModal () {
                this.$refs.activityLogForm.clearForm()
                this.$refs.activityLogForm.show();
            },
            hideModal () {
                this.$refs.activityLogForm.hide();
            },
            handleLogSaved($evt) {
                this.hideModal()
                if(this.currentLog){
                    this.successMessage.push('Successfully edited activity log')
                }else{
                    this.successMessage.push('Successfully created activity log')
                }
            },
            navigateBack() {
                window.location = this.$basePath+'/action-plans/'+this.actionPlan.mostRecentAssessment.survey.slug+'/'+this.actionPlan.mostRecentAssessment.id+'/start'
            },
            saveActionPlan() {
                this.$refs.goalDate.setDays();

                if(this.isStarted) {
                    this.closePendingRequest();
                    this.edit = false
                } else {
                    this.startActionPlan();
                }
            }
        },
        mounted() {
            this.syncActionPlan();
            if (!this.isStarted && this.isProgramUser) {
                this.edit = true
            }
        }
    
}
</script>